import type { LocaleString, Lang } from '@autoplan/web-sanity'
export { detectLang } from '@autoplan/web-sanity'
export type { LocaleString, Lang }

export const t = (obj: LocaleString | undefined, lang: Lang): string => obj?.[lang] ?? obj?.nb ?? obj?.en ?? ''
